/**
 * useUser Application Hook
 */

import { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useQueryClient } from 'react-query';
import { UserService, ImageService } from '../support/services/api';
import { setAuthData } from '../support/store/AuthReducer';

export default function useUser(userData) {
  const queryClient = useQueryClient();
  const dispatch = useDispatch();
  const [isUpdating, setUpdating] = useState();
  const [isUpdated, setUpdated] = useState();
  const [emailAvailable, setEmailAvailable] = useState();
  const [whatsappAvailable, setWhatsappAvailable] = useState();
  const [nicknameAvailable, setNicknameAvailable] = useState();
  const [queriesChecked, setQueriesChecked] = useState();
  const [data, setData] = useState(userData ?? {});

  useEffect(() => {
    if (
      typeof emailAvailable !== 'undefined'
   && typeof whatsappAvailable !== 'undefined'
   && typeof nicknameAvailable !== 'undefined') setQueriesChecked(true);
    else setQueriesChecked(undefined);
  }, [emailAvailable, whatsappAvailable, nicknameAvailable]);

  const checkEmail = (userId) => UserService().getByEmail(data.email).then(
    (res) => setEmailAvailable(!res.length || res[0]?.id === userId),
  );

  const checkWhatsapp = (userId) => UserService().getByWhatsapp(data.whatsapp).then(
    (res) => setWhatsappAvailable(!res.length || res[0]?.id === userId),
  );

  const checkNickname = (userId) => UserService(true).getByName(data.nickname).then(
    (res) => setNicknameAvailable(res.id === userId),
  ).catch(() => setNicknameAvailable(true));

  const updateData = async (data) => {
    setUpdating(true);
    const { img, id, ...noImgData } = data;

    if (img) {
      await ImageService().uploadImage({
        dataUrl: data.img,
        imageable_type: 'user',
      });
    }

    UserService().update({ body: noImgData }).then(() => {
      queryClient.invalidateQueries('user');
      dispatch(setAuthData(data));
      setUpdating(false);
      setUpdated(true);
    }).catch((err)=>setUpdating(false));
  };

  const resetSharedStates = () => {
    setEmailAvailable(undefined);
    setWhatsappAvailable(undefined);
    setNicknameAvailable(undefined);
  };

  const changeUserData = (attribute, value) => {
    if (attribute === 'multiple') return setData({ ...data, ...value });
    setData({ ...data, [attribute]: value });
  };

  useEffect(()=>{
    if(isUpdated) setUpdated(false);
  }, [isUpdated]);

  return {
    commands: {
      updateData,
      resetSharedStates,
      changeUserData,
    },
    sharedStates: {
      queriesChecked,
      emailAvailable,
      whatsappAvailable,
      nicknameAvailable,
      data,
    },
    queries: {
      checkEmail,
      checkWhatsapp,
      checkNickname,
    },
    metaStates:{
      isUpdating,
      isUpdated
    }
  };
}
